  <div class="tutor-mini"
       [class.row-5]="display_mode === 'row'"
       (click)="clicked.emit(user)">
    <div class="avatar-wrap">
      <on-ui-cover [cover]="avatar"></on-ui-cover>
    </div>
    <h5 class="full-name">{{ user?.title }}</h5>
    <div *ngIf="!hide_classes" class="classes-count">{{ user?.stats?.meetings_count || 0 }} classes</div>
  </div>
